import React from 'react'
import { Modal as MuiModal, ModalProps } from '@mui/material'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Close } from '@emotion-icons/material/Close'
import { Flex } from 'src/components/flex-containers'

const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 80vw;
  height: 80vh;
  background: ${Colors.bgWhite};
  border-radius: ${Shapes.borderRadius}px;
  overflow: hidden;
`

export const ModalSidebar = styled.div`
  width: ${Shapes.printModalSidebarWidth}px;
  flex: 0 0 ${Shapes.printModalSidebarWidth}px;
  height: 100%;
  border-right: 1px solid ${Colors.border};
  padding-top: ${Shapes.spacing[4]}px;
`

export const ModalSidebarTitle = styled.div`
  padding: ${Shapes.spacing[4]}px ${Shapes.spacing[6]}px;
  margin-bottom: ${Shapes.spacing[5]}px;
  display: flex;
  justify-content: space-between;
`

export const ModalBody = styled(Flex)`
  padding: ${Shapes.spacing[6]}px 70px;
  background-color: ${Colors.bgMedium};
  flex: 1 1 auto;
`

type Props = ModalProps & {
  backdropStyle?: React.CSSProperties
}

export type CloseProps = {
  style?: React.CSSProperties
  size?: number
  color?: string
  onClick: (e: React.MouseEvent<HTMLElement>) => void
}

export const IconContainer = styled.div`
  position: absolute;
  right: ${Shapes.spacing[2]}px;
  cursor: pointer;
`

export const CloseIcon: React.FC<CloseProps> = ({ style, size = 18, color, onClick }) => (
  <IconContainer style={style} onClick={onClick}>
    <Close size={size} color={color} />
  </IconContainer>
)

export const Modal: React.FC<Props> = ({ backdropStyle, ...props }) => {
  return (
    <MuiModal
      {...props}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...backdropStyle,
      }}>
      <ModalContent style={props.style}>{props.children}</ModalContent>
    </MuiModal>
  )
}
